import React, { useEffect, useState, useContext } from "react";
import Button from "../SelectValue/Button";
import PinInput from "react-pin-input";
import { useNavigate } from "react-router-dom";
import SavingSuccess from "./SavingSuccess";
import postService from "../../Services/post-service";
import getServices from "../../Services/get-service";
import Loading from "../SelectValue/Loading";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { usePaystackPayment } from "react-paystack";

import { format, addMonths, differenceInDays, differenceInWeeks, differenceInMonths } from "date-fns";
import Shimmer from "../SelectValue/Shimmer";
import { UserContext } from "../../Context/UserContext";

function MakePayment() {
  const { userDetails } = useContext(UserContext);
  const [pin, setPin] = useState("");
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const user = userDetails || {};
  const email = user.emailAddress;
  const amount = sessionStorage.getItem("savingsAmount");
  const name = sessionStorage.getItem("savingsName");
  const fre = sessionStorage.getItem("savingsFre");
  const type = sessionStorage.getItem("savingsType");
  const startDate = sessionStorage.getItem("startDate");
  // const endDate = sessionStorage.getItem('savingEndDate')
  const duration = sessionStorage.getItem("savingDuration");
  const formattedDate = startDate
    ? format(new Date(startDate), "yyyy-MM-dd")
    : null;

  const navigate = useNavigate();
  const handleClose = () => setOpen(false);
  const handleOpen = () => setOpen(true);

  const onSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    const upperType = type ? type.toUpperCase() : type;
    const upperFre = fre ? fre.toUpperCase() : fre;
    const mappedDuration = duration === "THREE_MONTH" ? "THREE_MONTHS"
      : duration === "SIX_MONTH" ? "SIX_MONTHS"
        : duration === "NINE_MONTH" ? "NINE_MONTHS"
          : duration;

    const paymentMethod = sessionStorage.getItem('paymentMethod') || 'WALLET';

    postService
      .savings(
        Number(amount?.toString().replace(/,/g, "")),
        mappedDuration,
        upperFre,
        name,
        pin,
        upperType,
        paymentMethod,
        formattedDate,
        true,
      )
      .then(
        (response) => {
          setLoading(false);
          if (response.data.statusCode === 200) {
            toast.success("Transaction Successful");
            if (paymentMethod === 'BANK' && response.data.data && response.data.data.directDebitUrl) {
              window.location.href = response.data.data.directDebitUrl;
            } else {
              navigate("/save", {
                replace: true,
                state: { showSuccess: true, planType: type },
              });
            }
          } else {
            toast.error(response.data.description);
          }
        },
        (error) => {
          setLoading(false);
          return toast.error(error.response.data.description, {
            position: toast.POSITION.TOP_RIGHT,
          });
        },
      );
  };

  const onSuccess = () => {
    // Implementation after success call.
  };

  const onClose = () => {
    // implementation for when the Paystack dialog closed.
  };

  return (
    <div>
      <div className=" h-[40vh] ">
        <div className="">
          {loading ? (
            <div className="mt-5">
              {/* <p className=" text-[18px] text-back-color2 mb-5  font-[500]">
                Processing Transaction...
              </p> */}
              <Shimmer type="rect" />
              <div className="mt-4">
                <Shimmer type="text" />
              </div>
            </div>
          ) : (
            <>
              <p className=" text-[18px] text-back-color2 mb-5  font-[500]">
                Enter your Zouse PIN
              </p>
              <p className=" mb-3 text-[#44474E]">
                Enter your 4-Digit PIN to confirm transaction
              </p>
              <div className="  mt-5">
                <div>
                  <form onSubmit={onSubmit}>
                    <div className=" w-full flex justify-center">
                      <PinInput
                        length={4}
                        initialValue={pin}
                        secret
                        onChange={(value, index) => {
                          setPin(value);
                        }}
                        type="numeric"
                        inputMode="number"
                        style={{ padding: "8px" }}
                        inputStyle={{
                          borderColor: "#00BC67",
                          backgroundColor: "#FAFBFC",
                          borderRadius: 8,
                          margin: "0 5px",
                          width: "50px",
                          height: "50px",
                        }}
                        inputFocusStyle={{
                          borderColor: "#00BC67",
                          backgroundColor: "#CCF2E1",
                        }}
                        onComplete={(value, index) => {
                          setPin(value);
                        }}
                        autoSelect={true}
                        regexCriteria={/^[ A-Za-z0-9_@./#&+-]*$/}
                      />
                    </div>
                    <div className=" grid grid-cols-1 mb-5 mt-6">
                      <Button name="Confirm" />
                    </div>
                  </form>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default MakePayment;
